import { TransportBatchPayload } from "./http";

export class BeaconTransport {
  public static send(endpoint: string, apiKey: string, payload: TransportBatchPayload): boolean {
    const url = `${endpoint.replace(/\/$/, "")}/v1/tracking/events/batch?apiKey=${encodeURIComponent(apiKey)}`;
    const data = JSON.stringify(payload);

    // 1. Try navigator.sendBeacon
    if (typeof navigator !== "undefined" && typeof navigator.sendBeacon === "function") {
      try {
        const blob = new Blob([data], { type: "application/json" });
        const enqueued = navigator.sendBeacon(url, blob);
        if (enqueued) return true;
      } catch {}
    }

    // 2. Fallback to fetch with keepalive: true
    if (typeof fetch === "function") {
      try {
        fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${apiKey}`,
            "X-Thrico-Api-Key": apiKey,
          },
          body: data,
          keepalive: true,
        }).catch(() => {});
        return true;
      } catch {}
    }

    return false;
  }
}
